import styled from 'styled-components';

interface DividerProps {
  separatorMargin?: string;
  separatorWidth?: string;
}

/**
 * For visually separating components in vertical layout.
 *
 * @param separatorMargin - adjust the margin of the separators
 * @param separatorWidth - adjust the width of the separators
 *
 * Defaults worked for text:  'Or, sign in with your email'
 */
const Divider = styled.div<DividerProps>`
  color: ${(props) => props.theme.colors.darkBlue};
  font-family: Inter;
  height: 20px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before,
  &::after {
    background-color: #dddddd;
    content: '';
    display: block;
    height: 2px;
    width: ${({ separatorWidth }) => separatorWidth};
  }

  &::before {
    margin-right: ${({ separatorMargin }) => separatorMargin};
  }

  &::after {
    margin-left: ${({ separatorMargin }) => separatorMargin};
  }
`;

Divider.defaultProps = {
  separatorMargin: '19px',
  separatorWidth: '120px',
};

export default Divider;
